
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
    };
  },
  mounted() {
    const htmlTag = document.querySelector("html");
    if (this.loading) {
      htmlTag.classList.add("no-scroll");
    } else {
      htmlTag.classList.remove("no-scroll");
    }
  },
  beforeDestroy() {
    const htmlTag = document.querySelector("html");
    htmlTag.classList.remove("no-scroll");
  },
};
